import { CommercialSupplier } from "../models/CommercialSupplier";
import api from "./api";

// System.Text.Json do backend não aceita date-only: preserva o "wall-clock" sem deslocar fuso.
const normalize = (supplier: CommercialSupplier): CommercialSupplier => ({
  ...supplier,
  orderDate: supplier.orderDate ? `${supplier.orderDate.substring(0, 10)}T00:00:00` : null,
});

export const getCommercialSuppliers = async (): Promise<CommercialSupplier[]> => {
  const response = await api.get("/api/commercialSupplier");
  return response.data ?? [];
};

export const saveCommercialSupplier = async (supplier: CommercialSupplier) =>
  api.post("/api/commercialSupplier", normalize(supplier));

export const updateCommercialSupplier = async (supplier: CommercialSupplier) =>
  api.put(`/api/commercialSupplier/${supplier.id}`, normalize(supplier));

export const deleteCommercialSupplier = async (id: string) =>
  api.delete(`/api/commercialSupplier/${id}`);
